import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface CouponYearlyObservationsFormFieldProps {}

export const CouponYearlyObservationsFormField: React.FC<
  CouponYearlyObservationsFormFieldProps
> = ({}) => {
  const { control, register } = useFormContext<{ coupon_yearly_observations: number }>()

  return (
    <FormField
      name="coupon_yearly_observations"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center justify-between gap-2">
              <FormLabel>Coupon Yearly Observations</FormLabel>
              {/* <FormError /> */}
            </div>
            <ControlledNumberInput {...register('coupon_yearly_observations')} />
          </FormItem>
        )
      }}
    />
  )
}
